const DiscountModel = {
  end_date: "date",
  start_date: "date",
}

export default DiscountModel
